<template>
  <div class="question-container">
    <div class="question">
			<wes-question v-bind:question="question" :qId="question.displayId" :isStandardSurvey="isStandardSurvey" @update-status="onUpdateStatus"></wes-question>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WesQuestionContainer',
  props: {
    question: Object,
    isStandardSurvey: Boolean
  },
  methods: {
    onUpdateStatus: function (status) {
      this.$emit('update-status', status);
    }
  }
};
</script>

<style scoped>
.question-container {
	min-height: 100px;
	font-size: 14px;
	width: 100%;
}
.buttons-container {
  height: 46px;
}
.button {
  float: right;
  margin: 5px 25px;
}
</style>
